import Authorized from '../../components/Authorization/Authorized';
import { Menu, Popconfirm, Space } from 'antd';
import { DeleteOutlined, EditOutlined, QuestionCircleOutlined } from '@ant-design/icons';
import React from 'react';
import momenth from 'moment-hijri';

import moment from 'moment';

export const rowStyle = {
  marginLeft: 20,
  marginRight: 20,
};

export const getOperationType = (id) => {
  if (id) {
    return {
      type: 'Update',
      method: 'PUT',
    };
  } else {
    return {
      type: 'Add',
      method: 'POST',
    };
  }
}

export const getTableMenuItems = (t, onMenuClick, handleSingleDelete) => {
  return (
    <div>
      <Authorized asset="item" operation="write">
        <Menu onClick={onMenuClick}>
          <Menu.Item key="edit">
            <Space direction="horizontal">
              <EditOutlined />
              {t('common.update')}
            </Space>
          </Menu.Item>
          <Menu.Item key="delete">
            <Popconfirm
              title={t('common.confirmation')} 
              description={t('common.areYouSureToDelete')} 
              placement="left"
              icon={<QuestionCircleOutlined style={{ color: 'red' }} />}
              onConfirm={handleSingleDelete}
              okButtonProps={{ size: 'middle' }}
              okText={t('common.yes')} 
              cancelButtonProps={{ size: 'middle' }}
              styles={{ body: { padding: 16 } }}
            >
              <Space direction="horizontal">
                <DeleteOutlined />
                {t('common.delete')}
              </Space>
            </Popconfirm>
          </Menu.Item>
        </Menu>
      </Authorized>
    </div>
  )
}
moment.locale('en');

export const pageSizeOptions = [
  '10',
  '20',
  '30',
  '40',
  '50',
  '100',
  '200',
  '500',
  '1000',
]

export const getHijriYear = gregorian => {
  return momenth(gregorian, 'YYYY-MM-DDTHH:mm:ss.SSSSZ')
    .locale('en')
    .format('iYYYY/iM/iD')
}

export const downloadBlob = (blob, fileName) => {
  const url = window.URL.createObjectURL(
    new Blob([blob]),
  );
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute(
    'download',
    fileName,
  );

  // Append to html link element page
  document.body.appendChild(link);

  // Start download
  link.click();

  // Clean up and remove the link
  link.parentNode.removeChild(link);
}
